import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Icon } from '@/components/Icon';
import { EmptyState } from '@/components/primitives/EmptyState';
export function NotFound() {
    return (_jsx(EmptyState, { icon: _jsx(Icon, { name: "info", size: 32 }), title: "Page not found", body: "The route you requested doesn't exist.", cta: _jsx(Link, { to: "/dashboard", children: "Back to Dashboard" }) }));
}
